import { Logger } from '@hawtiosrc/core/logging'

export const pluginId = 'quartz'
export const pluginName = 'hawtio-quartz'
export const pluginPath = '/quartz'
export const log = Logger.get(pluginName)

export const jmxDomain = 'quartz'
